export default "__VITE_ASSET__DctJWRNK__"